import { setRestrictedAction } from 'src/redux/slices/appNotifications';
import { ModerationState, ProfileStatus } from 'src/types/UserInfo';
import { AppState } from 'src/redux/store';
import { useAppSelector, useAppDispatch } from 'src/redux/hooks';
import { PostErrors } from 'src/types/DiscussionPost';
import {
  threadDetailActions,
  selectThreadDetailOp,
} from 'src/redux/slices/threadDetailSlice';
import { redirectToLoginPage } from 'src/utils/request';
import { RestrictedActionTypes } from 'src/types/AppNotifications';

export default function useAppLevelValidators(additionalParams: { [key: string]: string }) {
  const { postId } = additionalParams;
  const dispatch = useAppDispatch();
  const {
    hasWriteAccess,
    profileStatus,
    moderationState,
  } = useAppSelector(({ userInfo }: AppState) => userInfo);
  const opPost = useAppSelector(selectThreadDetailOp);
  const { groups } = useAppSelector((state) => state.groups);
  let isNotGroupMember: boolean;
  if (opPost) {
    const { groupId } = opPost;
    isNotGroupMember = !!groupId && !groups[groupId]?.isMember;
  }

  const BASE_VALIDATORS = [
    () => {
      if (moderationState === ModerationState.silenced) {
        dispatch(setRestrictedAction(RestrictedActionTypes.silenced));
        return true;
      }
      return false;
    },
    () => {
      if (profileStatus !== ProfileStatus.unauthenticated && !hasWriteAccess) {
        dispatch(setRestrictedAction(RestrictedActionTypes.marketplace));
        return true;
      }
      return false;
    },
    () => {
      if (profileStatus !== ProfileStatus.registered) {
        redirectToLoginPage();
        return true;
      }
      return false;
    },
    () => {
      if (isNotGroupMember && postId) {
        dispatch(threadDetailActions.setError({ postId, postError: PostErrors.notGroupMember }));
        return true;
      }
      return false;
    },
  ];

  return BASE_VALIDATORS;
}
